import React from 'react'
import styles from './status-not-in-wonde.styles'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import StatusColor from '../shared/status-color/status-color'

const StatusNotInWonde = ({ classes, id, statusColor, onConnect }) => (
  <div className={classes.container}>
    <StatusColor color={statusColor} />
    <div>
      <h5 className={classes.title}>We cannot connect to your school’s MIS.</h5>
      <p>
        Please contact <a href="mailto:hello@pobble.com">hello@pobble.com</a> so
        we can help you resolve the issue. <br />
        In the meantime you can continue to use Pobble with data that has been
        entered manually.
      </p>
      <Button tall action={() => onConnect(id)}>
        Retry
      </Button>
    </div>
  </div>
)

export default injectSheet(styles)(StatusNotInWonde)
